import { useEffect, useCallback } from "react";

import { useMutation } from "@tanstack/react-query";
import { Flex, Heading1, Paragraph } from "@sopranodesign/pulse-components";

import { useAuth } from "../../hooks";
import { logout } from "../../api";

const Logout = () => {
  const { authenticated, logoutUser } = useAuth();

  const mutation = useMutation({
    mutationFn: logout,
    onSuccess: () => logoutUser(),
  });

  const handleLogout = useCallback(() => {
    !mutation.isPending && mutation.mutate();
  }, [mutation]);

  useEffect(() => {
    if (authenticated) {
      handleLogout();
    }
  }, [authenticated, handleLogout]);

  return (
    <Flex col fat yScreen center middle pad>
      <Heading1 style={{ fontSize: "2rem" }} mb textCenter>
        Logging you out
      </Heading1>
      <Paragraph secondary textCenter>
        Please wait and you will be logged out
      </Paragraph>
    </Flex>
  );
};

export default Logout;
